<template>
  <div>
    <div class="title">流程通用设置</div>
    <div class="generalMain">
      <Form ref="generalSettingForm" :model="generalData">
        <!-- 自动去重 -->
        <Card>
          <p slot="title">自动去重</p>
          <div>
            <Row :gutter="24">
              <Col :span="12">
                <div class="font16">同一审批人在流程中多次出现时，自动去重</div>
              </Col>
              <Col :span="12">
                <i-switch
                  v-model="generalData.rmMulti"
                  size="large"
                  true-color="#13ce66"
                  @on-change="rmMultiSwitch"
                >
                  <span slot="open">ON</span>
                  <span slot="close">OFF</span>
                </i-switch>
              </Col>
            </Row>
            <div>
              <RadioGroup
                v-model="generalData.rmMultiOneOrMany"
                vertical
                @on-change="rmMultiOneOrManyChange"
              >
                <Radio label="one">
                  <span>在流程中出现多次时，仅保留第一个</span>
                </Radio>
                <Radio label="may">
                  <span>仅在连续出现时，自动去重</span>
                </Radio>
              </RadioGroup>
            </div>
            <Row :gutter="24">
              <Col :span="12">
                <div class="font16">审批人和发起人是同一个人</div>
              </Col>
              <Col :span="12">
                <i-switch
                  v-model="generalData.applyAuditSwitch"
                  size="large"
                  true-color="#13ce66"
                  @on-change="applyAuditSwitchChange"
                >
                  <span slot="open">ON</span>
                  <span slot="close">OFF</span>
                </i-switch>
              </Col>
            </Row>
            <div>
              <RadioGroup
                v-model="generalData.applyAuditSetting"
                vertical
                @on-change="applyAuditChange"
              >
                <Radio label="s1">
                  <span>自动通过</span>
                </Radio>
                <Radio label="s2">
                  <span>该流程审批、办理节点屏蔽该审批人</span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
        </Card>
        <!-- 撤销修改 -->
        <Card style="margin: 10px 0; padding-bottom: 10px;">
          <p slot="title">撤销/修改</p>
          <!-- 撤销设置 -->
          <div>
            <Row :gutter="24">
              <Col :span="12"><div class="font16">撤销设置</div></Col>
            </Row>
            <div>
              <Checkbox v-model="generalData.allowRecall">
                允许提交人撤销
                <FormItem
                  class="inlineFormItem"
                  prop="allwRecallSetDay"
                  :rules="{
                    required: generalData.allowRecall,
                    validator: validatorNumber
                  }"
                >
                  <InputNumber
                    number
                    :disabled="!generalData.allowRecall"
                    v-model="generalData.allwRecallSetDay"
                    style="width: 150px;"
                    :min="1"
                  />
                </FormItem>
                天内已通过的审批单
              </Checkbox>
              <br />
              <Checkbox v-model="generalData.allowWithdrawAuditDays">
                允许提交人撤销审批中的审批单（最多90天）
              </Checkbox>
            </div>
          </div>
          <!-- 修改设置 -->
          <div style="margin-top: 10px">
            <Row :gutter="24">
              <Col :span="12"><div class="font16">修改设置</div></Col>
            </Row>
            <div>
              <Checkbox v-model="generalData.allowAuditEdit">
                允许提交人修改审批中的审批单（最多90天）
              </Checkbox>
              <br />
              <Checkbox v-model="generalData.allowEdit">
                只允许修改
                <FormItem
                  class="inlineFormItem"
                  prop="allwAuditSetDay"
                  :rules="{
                    required: generalData.allowEdit,
                    trigger: 'blur',
                    validator: validatorNumber
                  }"
                >
                  <InputNumber
                    :disabled="!generalData.allowEdit"
                    v-model="generalData.allwAuditSetDay"
                    style="width: 150px;"
                    :min="1"
                  />
                </FormItem>
                天内提交并通过的审批，最多只允许修改
                <FormItem
                  class="inlineFormItem"
                  prop="allwAuditSetTime"
                  :rules="{
                    required: generalData.allowEdit,
                    validator: validatorNumber
                  }"
                >
                  <InputNumber
                    :disabled="!generalData.allowEdit"
                    v-model="generalData.allwAuditSetTime"
                    style="width: 150px;"
                    :min="1"
                  />
                </FormItem>
                次
              </Checkbox>
            </div>
          </div>
        </Card>
        <div class="otherSetting">
          <!-- 允许加签 -->
          <div class="itemBox generalSettingItem">
            <div class="title">允许加签</div>
            <i-switch
              v-model="generalData.allowAddAduit"
              size="large"
              true-color="#13ce66"
            >
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-switch>
          </div>
          <!-- 只能退回上一审批节点 -->
          <div class="itemBox generalSettingItem">
            <div class="title">只能退回上一审批节点</div>
            <i-switch
              v-model="generalData.onlyRollbackLast"
              size="large"
              true-color="#13ce66"
            >
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-switch>
          </div>
          <!-- 是否可以打回发起人 -->
          <div class="itemBox generalSettingItem">
            <div class="title">是否可以打回发起人</div>
            <i-switch
              v-model="generalData.allowRollbackApply"
              size="large"
              true-color="#13ce66"
            >
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-switch>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import { checkDataMap } from './modalConfig';
export default {
  name: 'GeneralSetting',
  props: ['generalData'],
  data() {
    return {};
  },
  methods: {
    validateSettingForm() {
      let flag = true;
      this.$refs.generalSettingForm.validate(valid => {
        if (!valid) {
          flag = false;
        }
      });
      return flag;
    },
    validatorNumber(rule, value, callback) {
      const { field } = rule;
      const preName = checkDataMap[field];
      if (this.generalData[preName]) {
        if (!value) {
          callback(new Error('不能为空'));
        } else if (!/^[1-9]\d*$/.test(value)) {
          callback(new Error('只能输入正整数'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    rmMultiOneOrManyChange(value) {
      if (['one', 'may'].includes(value)) {
        this.generalData.rmMulti = true;
      }
    },
    // radio任选一个，即打开开关
    applyAuditChange(value) {
      if (['s1', 's2'].includes(value)) {
        this.generalData.applyAuditSwitch = true;
      }
    },
    rmMultiSwitch(value) {
      if (!value) {
        this.generalData.rmMultiOneOrMany = '';
      } else {
        this.generalData.rmMultiOneOrMany = 'one';
      }
    },
    // 默认选择-自动通过radio
    applyAuditSwitchChange(value) {
      if (!value) {
        this.generalData.applyAuditSetting = '';
      } else {
        this.generalData.applyAuditSetting = 's1';
      }
    }
  }
};
</script>
<style lang="less" scoped>
.inlineFormItem {
  display: inline-block;
}
.title {
  font-size: 16px;
  margin-bottom: 10px;
}
.font16 {
  font-size: 16px;
}
.generalMain {
  padding: 10px 15px;
}
.otherSetting {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  // padding: 10px 15px;
  .generalSettingItem {
    margin-right: 20px;
  }
}
.itemBox {
  width: 250px;
  height: 100px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  .title {
    font-size: 16px;
  }
}
</style>
